// ===================================== constants ===================

import { ENUM_ATE_ROLES } from '../enumerators/system-enum';
import { ModelStrStr } from './ate-all-applications-model';

export const GUID_ADMIN = 'f0000000-0000-0000-0000-00000000000f';
export const GUID_NEW = '00000000-0000-0000-0000-000000000000';
export const ISNUMERIC = '^[0-9]*$';
export const ISNUMERICORDECIMAL = '^[1-9]d*(,d+)?$';
// export const ISALPHANUMERIC = '^(?!s)(?!.*s$)[A-Za-z0-9]*$';
export const ISALPHANUMERIC = '^[a-zA-Z0-9]+$';

export const ISUSERNAME = '^[a-zA-Z0-9@._-]{3,64}$';
export const ISUSERNAMESTRICT = '^(?=.{8,20}$)(?![_.])(?!.*[_.]{2})[a-zA-Z0-9._]+(?<![_.])$';
export const ISIP =
  '^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9]).){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])$';
export const ISTARGA = '^[A-Za-z0-9-]*$';
export const NOSPACES = '^[\\S]*$';
export const ISEMAIL = '^[a-zA-Z0-9.-_-]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,10}';
export const FONTAWESOME = '^.*</i>.*$';

export const ERR_PAGE_PATH = 'err-x-page';

export const SELECT_ROLES: ModelStrStr[] = [
  { Value: ENUM_ATE_ROLES.USER, Text: 'USER' },
  { Value: ENUM_ATE_ROLES.ADMIN, Text: 'ADMIN' },
  { Value: ENUM_ATE_ROLES.CONNECT_DATA, Text: 'CONNECT_DATA' },
];
export const SELECT_CULTURES: ModelStrStr[] = [
  { Value: 'it', Text: 'Italiano' },
  { Value: 'en', Text: 'English' },
  { Value: 'fr', Text: 'Français' },
  { Value: 'pl', Text: 'Polski' },
];
export const MIN_DATE_ISO = '2020-01-01T00:00:00.000';

// ----- constants ionic e web ------ //
export const DEMO_HOSTNAME = 'demo.diin.cloud';
export const DEMO_PASS = 'AteleDemo!';
export const DEMO_USER = 'demo';
export const DEMO_TEL_NUMBER = '1234567890';
export const DEFAULT_CULTURE = 'it';

export const TRADUZIONI_CONSENTITE: string[] = ['en', 'it', 'fr', 'pl'];
